import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'initializers/types';

import { Role, TimeClockType } from 'features/SharedTimeclock/slice';

import { TIME_CLOCK_MODAL_SLICE } from './constants';

type ModalViews = 'pin' | 'rateShift' | 'focusedShift';

export type TimeClockModalView = ModalViews | TimeClockType;

export interface TimeClockModalState {
  isOpen: boolean;
  isLoading: boolean;
  error: string | undefined;
  currentView: TimeClockModalView;
  pendingAction?:
    | {
        type: 'clockIn' | 'clockOut';
        shiftId: number;
      }
    | {
        type: 'createUnscheduledShift';
        jobId: number;
        role: Role;
      }
    | {
        type: 'startBreak';
        shiftId: number;
        mbId: number;
      }
    | {
        type: 'endBreak';
        shiftId: number;
        mbId: number;
      };
}

const initialState: TimeClockModalState = {
  isOpen: false,
  isLoading: false,
  error: undefined,
  currentView: 'pin',
  pendingAction: undefined,
};

// Slice
const TimeClockModalSlice = createSlice({
  name: TIME_CLOCK_MODAL_SLICE,
  initialState,
  reducers: {
    openTimeClockModal(state) {
      state.isOpen = true;
    },
    setTimeClockModalIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    closeTimeClockModal(state) {
      state.isOpen = false;
      state.isLoading = false;
      state.error = undefined;
      state.currentView = 'pin';
      state.pendingAction = undefined;
    },
    setTimeClockModalView(state, action) {
      state.error = undefined;
      state.currentView = action.payload;
    },

    setTimeClockModalError(state, action) {
      state.error = action.payload;
    },

    setPendingAction(state, action) {
      state.pendingAction = action.payload;
    },
  },
});

// Actions
export const {
  openTimeClockModal,
  closeTimeClockModal,
  setTimeClockModalError,
  setTimeClockModalView,
  setTimeClockModalIsLoading,
  setPendingAction,
} = TimeClockModalSlice.actions;

export const { reducer } = TimeClockModalSlice;

export const selectTimeClockModalIsOpen = (state: RootState) =>
  state.get(TIME_CLOCK_MODAL_SLICE).isOpen;

export const selectTimeClockModalCurrentView = (state: RootState) =>
  state.get(TIME_CLOCK_MODAL_SLICE).currentView;

export const selectTimeClockModalError = (state: RootState) =>
  state.get(TIME_CLOCK_MODAL_SLICE).error;

export const selectTimeClockModalLoading = (state: RootState) =>
  state.get(TIME_CLOCK_MODAL_SLICE).isLoading;

export const selectPendingAction = (state: RootState) =>
  state.get(TIME_CLOCK_MODAL_SLICE).pendingAction;
